<template>
  <form class="at-infobox mt-0 form-styled-3" @submit.prevent="submit()">
    <div class="form-group col-md-8">
      <label>What to do?</label>
      <textarea name="email" class="form-control" 
        placeholder="Your request here...." rows="10"
        v-model="content"
      ></textarea>
      <small class="text-danger" v-if="errors.content">
        {{ errors.content[0] }}
      </small>
    </div>
    <div class="form-group col-md-8">
      <button class="btn btn-primary">
        Send Request
      </button>
    </div>
  </form>
</template>


<script>
import { authRequest } from '../../app/helpers';
import toastr from 'toastr';

export default {
  data() {
    return {
      content: '',
      errors: [],
    }
  },


  mounted() {
  },


  methods: {

    async submit() {
      const { content } = this.$data;

      this.errors = [];

      const req = await authRequest(
        this.$router, 
        '/user/admin_request', 
        { content }, 
        'post'
      );

      if (req.status) {
        toastr.success(req.message);
        this.content = '';
      } else {
        toastr.error(req.message);
        this.errors = req.errors || [];
      }
    },
  }
}
</script>